import { SortingState } from '@tanstack/react-table';

import { Sorting } from '../types/utility';

export const convertSortingStateToSorting = (
  sortBy: SortingState,
): Sorting | undefined => {
  if (sortBy.length === 0) return undefined;

  const [{ desc, id }] = sortBy;
  return { column: id, direction: desc ? 'desc' : 'asc' };
};
